import classNames from 'classnames';
import { ForwardedRef } from 'react';

import MuteIcon from '../icons/MuteIcon';
import BasicButton, { BasicButtonElement, BasicButtonProps } from './BasicButton';

import styles from '../../styles/buttons/control-button.module.css';

export interface MuteButtonProps extends BasicButtonProps {
    muted?: boolean;
}

function MuteButton({
    muted = false,
    className = null,
    ref: buttonRef = null,
    ...props
}: MuteButtonProps & { ref?: ForwardedRef<BasicButtonElement> | null }) {
    return (
        <BasicButton
            ref={buttonRef}
            className={classNames([styles.container, className])}
            {...props}
        >
            <MuteIcon muted={muted} className={styles.icon} />
        </BasicButton>
    );
}

export default MuteButton;
